'use client';

import { Grid, GridItem } from '@coolblue-development/freddy';
import type { PromoBox as PromoBoxType } from '@features/product/typings';

import PromoBox from '../PromoBox/PromoBox';

type PromoBoxesGridProps = {
  promoBoxes: PromoBoxType[];
  orientation: 'horizontal' | 'vertical';
};

export default function PromoBoxesGrid({ promoBoxes, orientation }: PromoBoxesGridProps) {
  const id = { id: 'product-insurance' };
  return (
    <Grid gap='section' {...id}>
      {promoBoxes.map((promoBoxProduct, index) =>
        promoBoxProduct?.id ? (
          <GridItem
            key={promoBoxProduct.id}
            column={{
              xs: 'span 12',
              lg: orientation === 'horizontal' ? 'span 6' : 'span 12'
            }}
            order={promoBoxProduct?.location === 'FIRST' ? 1 : undefined}
          >
            <PromoBox data={promoBoxProduct} index={index + 1} totalIndices={promoBoxes.length} />
          </GridItem>
        ) : null
      )}
    </Grid>
  );
}
